import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dev-harness-idr-input',
    loadComponent: () => import('./dev-harness-idr-input.component').then((m) => m.DevHarnessIdrInputComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('vlife-common').then((m) => m.VlLoginPageComponent),
    data: {
      redirectPath: '/dashboard',
      logoSrc: 'images/logo.png',
      brandName: 'Victoria Life',
      brandingImageSrc: 'images/branding-background.png',
    },
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./features/products/products.component').then((m) => m.ProductsComponent),
      },
      {
        path: 'products/create',
        loadComponent: () =>
          import('./features/products/product-form/product-form.component').then((m) => m.ProductFormComponent),
      },
      {
        path: 'products/:id',
        loadComponent: () =>
          import('./features/products/product-detail/product-detail.component').then((m) => m.ProductDetailComponent),
      },
      {
        path: 'products/:id/edit',
        loadComponent: () =>
          import('./features/products/product-form/product-form.component').then((m) => m.ProductFormComponent),
      },
      {
        path: 'policies',
        loadComponent: () =>
          import('./features/policies/policies.component').then((m) => m.PoliciesComponent),
      },
      {
        path: 'policies/create',
        loadComponent: () =>
          import('./features/policies/policy-master-select/policy-master-select.component').then((m) => m.PolicyMasterSelectComponent),
      },
      {
        path: 'policies/create/:masterPolicyNo',
        loadComponent: () =>
          import('./features/policies/policy-create/policy-create.component').then((m) => m.PolicyCreateComponent),
      },
      {
        path: 'policies/import',
        loadComponent: () =>
          import('./features/policies/policy-import-master-select/policy-import-master-select.component').then((m) => m.PolicyImportMasterSelectComponent),
      },
      {
        path: 'policies/import/:masterPolicyNo',
        loadComponent: () =>
          import('./features/policies/policy-import/policy-import.component').then((m) => m.PolicyImportComponent),
      },
      {
        path: 'policies/certificate-downloads',
        loadComponent: () =>
          import('./features/policies/certificate-downloads/certificate-downloads.component').then((m) => m.CertificateDownloadsComponent),
      },
      {
        path: 'policies/certificate-downloads/:id',
        loadComponent: () =>
          import('./features/policies/certificate-downloads/certificate-download-detail.component').then((m) => m.CertificateDownloadDetailComponent),
      },
      {
        path: 'policies/import-jobs',
        loadComponent: () =>
          import('./features/policies/policy-import-jobs/policy-import-jobs.component').then((m) => m.PolicyImportJobsComponent),
      },
      {
        path: 'policies/import-jobs/:masterPolicyNo',
        loadComponent: () =>
          import('./features/policies/policy-import-jobs/policy-import-jobs.component').then((m) => m.PolicyImportJobsComponent),
      },
      {
        path: 'policies/import-jobs/:importJobId/report',
        loadComponent: () =>
          import('./features/policies/policy-import-report/policy-import-report.component').then((m) => m.PolicyImportReportComponent),
      },
      {
        path: 'policies/:id/amendments/create',
        loadComponent: () =>
          import('./features/amendments/amendment-create/amendment-create.component').then((m) => m.AmendmentCreateComponent),
      },
      {
        path: 'policies/:id/cancellations/create',
        loadComponent: () =>
          import('./features/cancellations/cancellation-form/cancellation-form.component').then((m) => m.CancellationFormComponent),
      },
      {
        path: 'policies/:id/cancellations/:cnlId/edit',
        loadComponent: () =>
          import('./features/cancellations/cancellation-form/cancellation-form.component').then((m) => m.CancellationFormComponent),
      },
      {
        path: 'policies/:id/edit',
        loadComponent: () =>
          import('./features/policies/policy-edit/policy-edit.component').then((m) => m.PolicyEditComponent),
      },
      {
        path: 'policies/:id',
        loadComponent: () =>
          import('./features/policies/policy-detail/policy-detail.component').then((m) => m.PolicyDetailComponent),
      },
      {
        path: 'amendments',
        loadComponent: () =>
          import('./features/amendments/amendments.component').then((m) => m.AmendmentsComponent),
      },
      {
        path: 'amendments/import',
        loadComponent: () =>
          import('./features/amendments/amendment-import/amendment-import-master-select.component').then((m) => m.AmendmentImportMasterSelectComponent),
      },
      {
        path: 'amendments/import/:masterPolicyNo',
        loadComponent: () =>
          import('./features/amendments/amendment-import/amendment-import.component').then((m) => m.AmendmentImportComponent),
      },
      {
        path: 'amendments/import-jobs',
        loadComponent: () =>
          import('./features/amendments/amendment-import/amendment-import-jobs.component').then((m) => m.AmendmentImportJobsComponent),
      },
      {
        path: 'amendments/import-jobs/by-master/:masterPolicyNo',
        loadComponent: () =>
          import('./features/amendments/amendment-import/amendment-import-jobs.component').then((m) => m.AmendmentImportJobsComponent),
      },
      {
        path: 'amendments/import-jobs/:jobId/staging/:rowId/edit',
        loadComponent: () =>
          import('./features/amendments/amendment-import/amendment-import-staging-edit.component').then((m) => m.AmendmentImportStagingEditComponent),
      },
      {
        path: 'amendments/import-jobs/:id',
        loadComponent: () =>
          import('./features/amendments/amendment-import/amendment-import-job-detail.component').then((m) => m.AmendmentImportJobDetailComponent),
      },
      {
        path: 'amendments/:id',
        loadComponent: () =>
          import('./features/amendments/amendment-detail/amendment-detail.component').then((m) => m.AmendmentDetailComponent),
      },
      {
        path: 'cancellations',
        loadComponent: () =>
          import('./features/cancellations/cancellations.component').then((m) => m.CancellationsComponent),
      },
      {
        path: 'cancellations/import',
        loadComponent: () =>
          import('./features/cancellations/cancellation-import/cancellation-import-master-select.component').then((m) => m.CancellationImportMasterSelectComponent),
      },
      {
        path: 'cancellations/import/:masterPolicyNo',
        loadComponent: () =>
          import('./features/cancellations/cancellation-import/cancellation-import.component').then((m) => m.CancellationImportComponent),
      },
      {
        path: 'cancellations/import-jobs',
        loadComponent: () =>
          import('./features/cancellations/cancellation-import/cancellation-import-jobs.component').then((m) => m.CancellationImportJobsComponent),
      },
      {
        path: 'cancellations/import-jobs/by-master/:masterPolicyNo',
        loadComponent: () =>
          import('./features/cancellations/cancellation-import/cancellation-import-jobs.component').then((m) => m.CancellationImportJobsComponent),
      },
      {
        path: 'cancellations/import-jobs/:jobId/staging/:rowId/edit',
        loadComponent: () =>
          import('./features/cancellations/cancellation-import/cancellation-import-staging-edit.component').then((m) => m.CancellationImportStagingEditComponent),
      },
      {
        path: 'cancellations/import-jobs/:id',
        loadComponent: () =>
          import('./features/cancellations/cancellation-import/cancellation-import-job-detail.component').then((m) => m.CancellationImportJobDetailComponent),
      },
      {
        path: 'cancellations/:cnlId',
        loadComponent: () =>
          import('./features/cancellations/cancellation-detail/cancellation-detail.component').then((m) => m.CancellationDetailComponent),
      },
      {
        path: 'billings',
        loadComponent: () =>
          import('./features/billings/billings.component').then((m) => m.BillingsComponent),
      },
      {
        path: 'billings/:id',
        loadComponent: () =>
          import('./features/billings/billing-detail/billing-detail.component').then((m) => m.BillingDetailComponent),
      },
      {
        path: 'reports/sales',
        loadComponent: () =>
          import('./features/reports/reports-sales.component').then((m) => m.ReportsSalesComponent),
      },
      {
        path: 'reports/policies',
        loadComponent: () =>
          import('./features/reports/reports-policies.component').then((m) => m.ReportsPoliciesComponent),
      },
      {
        path: 'staging-policies',
        loadComponent: () =>
          import('./features/policies/policy-staging/policy-staging.component').then((m) => m.PolicyStagingComponent),
      },
      {
        path: 'staging-policies/:jobId/rows/:id/edit',
        loadComponent: () =>
          import('./features/policies/staging-policy-edit/staging-policy-edit.component').then((m) => m.StagingPolicyEditComponent),
      },
      {
        path: 'staging-policies/:id',
        loadComponent: () =>
          import('./features/policies/import-job-detail/import-job-detail.component').then((m) => m.ImportJobDetailComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/settings.component').then((m) => m.SettingsComponent),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
